import React from 'react'
import Original from './Original'

export default (): React.ReactElement<React.ComponentProps<any>, any> => (
  <>
    <Original />
  </>
)